// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".type[data-v-1ca272f6] {\n  width: 200px;\n}\n.box-line[data-v-1ca272f6]:focus-within {\n  color: var(--theme-color);\n}\n.estimated-value[data-v-1ca272f6] {\n  width: 125px;\n}\n.input-value[data-v-1ca272f6] {\n  width: 125px;\n}", ""]);
// Exports
module.exports = exports;
